import { useCartoLayerProps } from '@carto/react-api';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { useSelector, useDispatch } from 'react-redux';
import htmlForFeature from 'utils/htmlForFeature';
export const TRANSIT_ROUTE_LAYER_ID = 'transitRouteLayer';

export const CATEGORY_COLORS = {
  'Route Line': [241, 100, 119],
};

const layerConfig = {
  title: 'Transit Route segment',
};

function TransitRouteLayer(){
    const dispatch = useDispatch();
    const {transitRouteLayer} = useSelector((state)=> state.carto.layers);
    const source = useSelector((state)=>
    selectSourceById(state, transitRouteLayer?.source));
    const cartoLayerProps = useCartoLayerProps({source});
    const viewState = useSelector((state) => state.carto.viewState);
    const pointLineWidth = viewState.zoom >= 7 ? 5 : 2;

    if(transitRouteLayer && source) {
        return new CartoLayer({
            ...cartoLayerProps,
            id: TRANSIT_ROUTE_LAYER_ID,
            stroked: false,
            pointRadiusUnits: 'pixels',
            lineWidthUnits: 'pixels',
            pickable: true,
            visible: transitRouteLayer.visible,
            opacity: transitRouteLayer.opacity,
            getLineColor: [213, 100, 249],
            lineWidthMinPixels: pointLineWidth,
            onDataLoad: (data) => {
            dispatch(
                updateLayer({
                id: TRANSIT_ROUTE_LAYER_ID,
                layerAttributes: { ...layerConfig },
                })
            );
            cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
            },
            onHover: (info) => {
                        if (info?.object) {
                            info.object = {
                            html: htmlForFeature({
                                feature: info.object,
                            }),
                            };
                        }
                        },
        });
    }

}

export default TransitRouteLayer;